import { compose } from 'recompose';
import centeredQuestion from '../hoc/centeredQuestion';
import MultiChoiceQuestion from '../MultiChoiceQuestion';
import withE2EProp from '../../withE2EProp';

export default compose(
  withE2EProp('respondent-custom-multi'),
  centeredQuestion,
)(MultiChoiceQuestion);
